export enum IDV_TYPE_ENUM {
    DOB = 'DOB'
}
